import {
  Directive,
  ElementRef,
  HostBinding,
  Input,
  inject,
} from '@angular/core';
import { FormControl } from '@angular/forms';

@Directive({
  selector: '[procureLabelItem]',
})
export class LabelItemDirective {
  @Input() control!: FormControl;

  readonly elem = inject(ElementRef);

  private _class: string = 'label-value-list__label';

  @HostBinding('class')
  get class(): string {
    return this._class;
  }

  @HostBinding('class.label-value-list__label--invalid')
  get invalidClass(): boolean {
    return this.control?.touched && !this.control?.valid;
  }
}
